// Dependencies
import styled, { css } from "styled-components";

// Types
import { ActivityQuestionIndicatorVariant } from "./activity-question-indicator.types";

// Utils
import { theme } from "config/theme";

type ContainerStyleProps = {
    variant: ActivityQuestionIndicatorVariant;
};

export const Container = styled.div<ContainerStyleProps>`
    width: 24px;
    height: 24px;
    border-radius: 100px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    ${({ variant }) =>
        variant === "danger" &&
        css`
            background-color: ${theme.colors.system.danger[100]};
        `}

    ${({ variant }) =>
        variant === "default" &&
        css`
            background-color: ${theme.colors.base[100]};
        `}
    
    ${({ variant }) =>
        variant === "success" &&
        css`
            background-color: ${theme.colors.system.success[100]};
        `}
`;

type LabelStyleProps = {
    variant: ActivityQuestionIndicatorVariant;
};

export const Label = styled.p<LabelStyleProps>`
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    ${({ variant }) =>
        variant === "danger" &&
        css`
            color: ${theme.colors.system.danger[500]};
        `}

    ${({ variant }) =>
        variant === "default" &&
        css`
            color: ${theme.colors.base[500]};
        `}
    
    ${({ variant }) =>
        variant === "success" &&
        css`
            color: ${theme.colors.system.success[500]};
        `}
`;
